// inspired by https://github.com/shinnn/array-to-sentence/blob/master/index.js
const toSentence = list => {
  if (list.length === 0) {
    return ''
  }

  if (list.length === 1) {
    return list[0]
  }

  if (list.length === 2) {
    return list[0] + ' and ' + list[1]
  }

  // oxford comma FTW
  return list.slice(0, -1).join(', ') + ', and ' + list[list.length - 1]
}

// returns a function that can be provided as an argument to the ES6 array `sort` method.
const sortBy = property => (a, b) => {
  if (a[property] < b[property]) {
    return -1
  }
  if (a[property] > b[property]) {
    return 1
  }
  return 0
}

export { toSentence, sortBy }
